import { jsx } from "react/jsx-runtime";
import React__default from "react";
import { clamp } from "../helpers.js";
import { ChainableNumberInput } from "./chainable-number-input.js";
const MinutesInput = React__default.forwardRef((props, ref) => {
  const { value, onChange, onBlur, ...rest } = props;
  const handleBlur = (event) => {
    onBlur?.(event);
    if (value) {
      onChange?.(clamp(parseInt(value, 10), 0, 59).toString().padStart(2, "0"));
    }
  };
  return /* @__PURE__ */ jsx(
    ChainableNumberInput,
    {
      ref,
      min: 0,
      max: 59,
      value,
      onBlur: handleBlur,
      onChange,
      "data-hook": "minutes",
      ...rest
    }
  );
});
MinutesInput.displayName = "MinutesInput";
export {
  MinutesInput
};
//# sourceMappingURL=minutes-input.js.map
